import { Box, Typography } from "@mui/material";
import { Block, Button } from "../../../shared/";
import { v } from "../../../../utils/runtime";
import { useTranslation } from "react-i18next";

export function ApplePayBlock() {
  const { t } = useTranslation("home");
  const supportUrl = `https://t.me/zero_manager?text=${encodeURIComponent(
    t("apple_pay.message"),
  )}`;
  return (
    <Block
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <Box
        component="img"
        src={v("/apple-pay-background.png")}
        sx={{
          position: "absolute",
          top: 0,
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: "99",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Box
          sx={{
            margin: "1.25rem 0 1rem 0",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
            borderRadius: "6px",
          }}
          component="img"
          src={v("/apple-pay.svg")}
        />

        <Box sx={{ textAlign: "center", marginBottom: "1.25rem" }}>
          <Typography sx={{ fontSize: "20px", fontWeight: "500" }}>
            {t("apple_pay.title")}
          </Typography>
          <Typography sx={{ fontWeight: "300" }}>
            {t("apple_pay.description")}
          </Typography>
        </Box>

        <Button
          onClick={() => {
            Telegram.WebApp.openTelegramLink(supportUrl);
          }}
        >
          {t("apple_pay.cta")}
        </Button>

        <Typography
          sx={{ fontSize: "12px", opacity: ".6", paddingTop: ".75rem" }}
        >
          {t("apple_pay.support")}
        </Typography>
      </Box>
    </Block>
  );
}
